import moment from 'moment';
import { PeopleHRAPIKeyServerSide } from './people-hr-api-key-server-side.model';

export class PeopleHRAPIKey {

  id: number;
  token: string;
  created: Date;
  error: string | null;

  constructor(peopleHRAPIKeyServerSide: PeopleHRAPIKeyServerSide) {
    this.id = peopleHRAPIKeyServerSide.id;
    this.token = peopleHRAPIKeyServerSide.token;
    this.created = moment.utc(peopleHRAPIKeyServerSide.created).toDate();
    this.error = peopleHRAPIKeyServerSide.error;
  }

}